import { CurrencyAddressCell } from '@root/entities/currency/ui/cells/currency-address-cell'
import { WalletAssetsBalanceCell } from '@root/entities/wallet/ui/table/column/wallet-asset-column/wallet-assets-balance-cell'
import { WalletAssetsPriceCell } from '@root/entities/wallet/ui/table/column/wallet-asset-column/wallet-assets-price-cell'

import { HoldingsAssetsTokenCell } from './holdings-assets-token-cell'

import type { UserProfileHoldingsWalletAsset } from '../../model/user-profile-holdings-wallet-asset'
import type { Column } from '@root/shared/ui-kit'

export type HoldingsAssetsColumnId = 'name' | 'address' | 'balance' | 'price'

export const holdingsAssetsTableColumns: Array<
  Column<UserProfileHoldingsWalletAsset, HoldingsAssetsColumnId>
> = [
  {
    id: 'name',
    header: ({ t }) => t('token'),
    render: ({ value }) => <HoldingsAssetsTokenCell asset={value} />,
    minWidth: 100,
  },
  {
    id: 'address',
    header: ({ t }) => t('common.address'),
    render: ({ value }) => <CurrencyAddressCell currency={value.currency} />,
    minWidth: 100,
  },
  {
    id: 'balance',
    header: ({ t }) => t('common.balance'),
    render: ({ value }) => (
      <WalletAssetsBalanceCell
        ticker={value.ticker}
        balance={value.balance}
        balanceUsd={value.balanceUsd}
      />
    ),
    minWidth: 100,
    width: '1fr',
    sortable: true,
  },
  {
    id: 'price',
    header: ({ t }) => t('common.price'),
    render: ({ value }) => (
      <WalletAssetsPriceCell ticker={value.ticker} priceUsd={value.priceUsd} />
    ),
    minWidth: 100,
    width: '1.5fr',
  },
]
